const yotpo_modal = () => {
    let revPayload = {};

    const initPayload = () => {
        let scr;
        (revPayload["review_score"]) ? scr = revPayload["review_score"] : scr = 0;
        revPayload = {
            "sku": "",
            "product_title": "",
            "product_url": "",
            "email": JMO.currentUserEmail,
            "uid": JMO.customer.id,
            "display_name": "",
            "review_content": "",
            "review_title": "",
            "gender": "",
            "review_score": scr,
            "order_id": null
        }
        return revPayload;
    }

    const initYotpoForm = () => {
        document.body.onclick = null;

        let writeReviews = document.querySelectorAll(".lineItemWriteReview");
        writeReviews.forEach(function (btn) {
            btn.addEventListener("click", function (e) {
                let elmTarget = e.target;
                revPayload["product_url"] = "https://johnmastersorganics.jp" + elmTarget.getAttribute("data-product");
                revPayload["sku"] = elmTarget.getAttribute("data-sku");
                revPayload["product_title"] = elmTarget.getAttribute("data-title");
                revPayload["order_id"] = elmTarget.getAttribute("data-order-id");
                JMO.order_id = elmTarget.getAttribute('data-order-id');
                document.querySelectorAll("#overlay")[0].style.display = "flex"
            })
        });

        let closeTxt = document.getElementById("closeTxt");
        closeTxt.addEventListener("click", function (e) {
            document.querySelectorAll("#overlay")[0].style.display = "none";
            revPayload = initPayload();
            initHtml();
            e.preventDefault();
        })

    }

    const checkSubmit = async () => {
        let sku = revPayload["sku"];
        if (! document.getElementById("alert_check").checked) {
            document.getElementById("alertSubmit").style.display = "block";
            return false;
        }
        else if (revPayload["display_name"] === "" || revPayload["review_content"] === "" || revPayload["review_title"] === "" || revPayload["review_score"] === 0) {
            document.getElementById("alertSubmit").style.display = "block";
            return false;
        } else {
            document.getElementById("alertSubmit").style.display = "none";
            document.getElementById("overlay_content").style.display = "none";
            document.getElementsByClassName("loader")[0].style.display = "block";
            let res = await fetchGcf(revPayload);
            let res_json = await res.json();
            revPayload = initPayload();
            initHtml();
            if (res_json.result === 0) {
                //FAILURE
                document.getElementsByClassName("loader")[0].style.display = "none";
                document.getElementById("overlay_fail").style.display = "block";

                setTimeout(() => {
                    console.log("ng");
                    document.querySelectorAll("#overlay")[0].style.display = "none"
                    document.getElementById("overlay_content").style.display = "block";
                    document.getElementById("overlay_fail").style.display = "none";
                }, 3000)

            } else {
                //SUCCESS
                document.getElementsByClassName("loader")[0].style.display = "none";
                document.getElementById("overlay_success").style.display = "block";
                let elm = document.querySelectorAll(".lineItemWriteReview[data-sku='" + sku + "']")[0];
                elm.style.display = "none";

                setTimeout(() => {
                    console.log("ok");
                    document.querySelectorAll("#overlay")[0].style.display = "none"
                    document.getElementById("overlay_content").style.display = "block";
                    document.getElementById("overlay_success").style.display = "none";
                }, 3000)
            }
            return true;
        }

    }

    const fetchGcf = async(revPayload) => {
        const funcName = location.hostname == 'johnmastersorganics.jp' ? 'judgeme_reviews' : 'stg_judgeme_reviews-1';
        let url = `https://asia-northeast1-plasma-yeti-265801.cloudfunctions.net/${funcName}`;

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        return fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(revPayload)
        })
    }

    const initHtml = () => {
        ["display_name", "review_title", "review_content"].forEach(function(pl) {
            let elmIp = document.getElementById(pl)
            elmIp.value = "";
        });
    }

    const setPayload = () => {
        let elmRating = document.querySelectorAll("input[name=rating]")
        elmRating.forEach(function (e) {
            e.addEventListener("click", function (g) {
                revPayload["review_score"] = parseInt(e.getAttribute("value"))
            })
        });

        ["display_name", "review_title", "review_content"].forEach(function (pl) {
            let elmIp = document.getElementById(pl)
            elmIp.addEventListener("change", function (g) {
                revPayload[pl] = elmIp.value;
            })
        });

        document.getElementById("review_submit").addEventListener("click", function(e) {
            checkSubmit();
            e.preventDefault();
        })

    }

    const hideReviewed = () => {
        const itemReviews = document.querySelectorAll('.item-reviewed');
        itemReviews.forEach((itemReview) => {
            const data = itemReview.value ? JSON.parse(itemReview.value).items : [];
            const orderId = itemReview.getAttribute("data-order-id");
            const writeReviews = document.querySelectorAll(".lineItemWriteReview");

            writeReviews.forEach((writeReview) => {
                const sku = writeReview.getAttribute("data-sku");
                const itemOrderId = writeReview.getAttribute("data-order-id");
                if (data.indexOf(sku) !== -1 && itemOrderId === orderId) {
                    writeReview.style.display = "none";
                }
            });
        });
    }

    hideReviewed();
    revPayload = initPayload();
    initYotpoForm();
    setPayload();

}

window.addEventListener('DOMContentLoaded', (event) => {
    yotpo_modal();
});